import {observer} from 'mobx-react';


const CompareToggle = function() {

    return <span
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            height: '1.5rem',
            padding: '0 0.5rem',
            borderRadius: '0.75rem',
            background: '#e8daff',
            color: '#6929c4',
            fontSize: '0.75rem',
            lineHeight: '1.33333',
            whiteSpace: 'nowrap',
            fontWeight: 400,
        }}
    >
        Compare
        <svg width='12' height='12' viewBox='0 0 16 16' aria-hidden='true' style={{fill: 'none', stroke: 'currentColor', strokeWidth: 1}}>
            <circle cx='6.2' cy='8' r='4' /><circle cx='9.8' cy='8' r='4' />
        </svg>
    </span>;
};

export default observer(CompareToggle);